// extracted by mini-css-extract-plugin
export default {"Container":"Taken_Container__HmyDp","table":"Taken_table__NB2VY","video-icon":"Taken_video-icon__hWrLC","link-upload":"Taken_link-upload__6FA5z","progress":"Taken_progress__sGG6n"};